import React from 'react';

const DashboardPlantWorkCenterFilters = ({
  plantas,
  centrosTrabajoDePlanta,
  selectedPlantFilterId,
  onSelectPlantFilter,
  selectedWorkCenterFilterId,
  onSelectWorkCenterFilter,
}) => {
  const handlePlantClick = (plantId) => {
    onSelectPlantFilter(plantId);
  };

  const handleWorkCenterClick = (workCenterId) => {
    onSelectWorkCenterFilter(workCenterId);
  };

  return (
    <div className="bg-white p-4 rounded-2xl shadow-lg space-y-3">
      <h2 className="text-lg font-bold text-gray-900 mb-3">Filtrar por Ubicación</h2>
      
      {/* Filtros de Planta y Centro de Trabajo en la misma fila */}
      <div className="flex flex-col sm:flex-row gap-3">
        {/* Filtro por Planta con botones */}
        <div className="flex-1">
          <label className="block text-gray-700 text-sm font-medium mb-2">Por Planta:</label>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => handlePlantClick('')}
              className={`py-2 px-4 rounded-lg font-semibold transition-colors text-sm ${
                selectedPlantFilterId === ''
                  ? 'bg-black text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              Todas
            </button>
            {plantas.map(plant => (
              <button
                key={plant.id}
                onClick={() => handlePlantClick(plant.id)}
                className={`py-2 px-4 rounded-lg font-semibold transition-colors text-sm ${
                  selectedPlantFilterId === plant.id
                    ? 'bg-black text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                {plant.nombre.replace('Planta ', '')} {/* Compactar nombre */}
              </button>
            ))}
          </div>
        </div>

        {/* Filtro por Centro de Trabajo con botones (dependiente de la planta) */}
        {selectedPlantFilterId && (
          <div className="flex-1">
            <label className="block text-gray-700 text-sm font-medium mb-2">Por Centro de Trabajo:</label>
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => handleWorkCenterClick('')}
                className={`py-2 px-4 rounded-lg font-semibold transition-colors text-sm ${
                  selectedWorkCenterFilterId === ''
                    ? 'bg-black text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                Todos
              </button>
              {centrosTrabajoDePlanta.map(ct => (
                <button
                  key={ct.id}
                  onClick={() => handleWorkCenterClick(ct.id)}
                  className={`py-2 px-4 rounded-lg font-semibold transition-colors text-sm ${
                    selectedWorkCenterFilterId === ct.id
                      ? 'bg-black text-white'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                >
                  {ct.nombre}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardPlantWorkCenterFilters;